import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Login } from "../Components/login";
import { Dashboard } from "../Components/dashboard";
import { GlobalContext } from "../Context/globalContext";
import { Companies } from "../Components/companies";
import { Devices } from "../Components/devices";
import { DeviceSessions } from "../Components/sessions";

export const Routing = () => {
  const globalContext = useContext(GlobalContext);

  return (
    <>
      {globalContext.loggedIn ? (
        <Routes>
          <Route path="*" element={<Companies />} />
          <Route path="/devices/:company_key" element={<Devices />} />
          <Route
            path="/devices/:company_key/details/:device_id"
            element={<DeviceSessions />}
          />
          <Route path="/company/:company_key" element={<Dashboard />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      )}
    </>
  );
};
